import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: '#fff',
      color: '#696969',
    },
    grow: {
      flexGrow: 1,
      height: 'auto',
    },
    toolbar: {
      padding: theme.spacing(0),
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    sectionDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    sectionMobile: {
      display: 'flex',
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    logo: {
      width: '15%',
    },
    icon: {
      fontSize: 30,
    },
    avatar: {
      width: theme.spacing(6),
      height: theme.spacing(6),
      background: theme.palette.primary.light,
    },
    link: {
      color: 'inherit',
      textDecoration: 'inherit',
      width: 'auto',
    },
    notificationsMenu: {
      width: 'auto',
      maxWidth: '100%',
      maxHeight: '250px',
    },
    notificationItem: {
      color: '#696969',
      '&:hover': {
        background: 'hsl(206, 28%, 61%, 15%)',
      },
    },
    notifications: {
      padding: theme.spacing(3),
    },
    notificationsEnd: {
      padding: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    iconButton: {
      position: 'absolute',
      right: 0,
      top: '50%',
      transform: 'translateY(-50%)',
    },
    menuItemLink: {
      textDecoration: 'none',
      color: 'inherit',
      width: '100%',
    },
  }),
);
